export default {
  ADD_NEW_VEHICLE: 'Add new vehicle',
  ADD_NEW_USER: 'Add new user',
};
